import { withTheme } from 'foundations-theming/utils';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { List as FoundationsList } from 'foundations-components/transitional/components/List';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Text } from 'foundations-components/components/Text';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { View } from 'foundations-components/transitional/components/View';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { UndoIcon } from 'foundations-assets/icons/components/UndoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUBMISSIONS = 'submissions';
function langKey(key) {
  return `mab.${key}`;
}
function isValid(variation) {
  return variation.get('error').length === 0;
}
class MABExperimentModalControlsFieldsWithoutTheme extends Component {
  constructor(...args) {
    super(...args);
    this.getDeletedVariationComponents = (variation, index) => ({
      inputField: /*#__PURE__*/_jsx(FormControl, {
        "aria-label": "Deleted variation name",
        children: /*#__PURE__*/_jsx(Text, {
          as: "div",
          textDecoration: "line-through",
          color: "text-core-disabled",
          children: /*#__PURE__*/_jsx(TextInput, {
            value: variation.get('name'),
            readOnly: true
          })
        })
      }),
      sideButton: /*#__PURE__*/_jsx(IconButton, {
        onClick: () => {
          var _this$props$onDeleteV, _this$props;
          return (_this$props$onDeleteV = (_this$props = this.props).onDeleteVariationUndo) === null || _this$props$onDeleteV === void 0 ? void 0 : _this$props$onDeleteV.call(_this$props, index);
        },
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('deleteVariationUndo')
        }),
        use: "transparent",
        children: /*#__PURE__*/_jsx(UndoIcon, {})
      })
    });
    this.getNewVariationComponents = (variation, index) => {
      const {
        onDeleteVariation,
        onVariationNameChange,
        variations
      } = this.props;
      return {
        inputField: /*#__PURE__*/_jsx(FormControl, {
          "aria-label": "New variation name",
          error: !isValid(variation),
          validationMessage: this.renderVariationValidationMessage(variation),
          children: /*#__PURE__*/_jsx(TextInput, {
            onChange: event => onVariationNameChange(index, event),
            value: variation.get('name')
          })
        }),
        sideButton: variations.size > 1 && /*#__PURE__*/_jsx(IconButton, {
          onClick: () => onDeleteVariation(index),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('deleteVariation')
          }),
          use: "transparent",
          children: /*#__PURE__*/_jsx(DeleteIcon, {})
        })
      };
    };
    this.getVariationComponents = (variation, index) => variation.get('deleted') ? this.getDeletedVariationComponents(variation, index) : this.getNewVariationComponents(variation, index);
    this.renderNewVariation = (variation, index) => {
      if (this.props.mabExperimentIsStarted) {
        return /*#__PURE__*/_jsx(View, {
          marginBlockEnd: "200",
          as: "span",
          children: variation.get('name')
        }, index);
      }
      const {
        inputField,
        sideButton
      } = this.getVariationComponents(variation, index);
      return /*#__PURE__*/_jsx(MediaObject, {
        itemRight: sideButton,
        marginBlockEnd: "200",
        children: inputField
      }, index);
    };
  }
  getShowAddVariationButton() {
    const {
      maxVariations,
      variations,
      mabExperimentIsStarted
    } = this.props;
    if (mabExperimentIsStarted) {
      return false;
    }
    const variationCount = variations.filter(variation => !variation.get('deleted')).size;
    return variationCount < maxVariations - 1;
  }
  renderAddVariationButton() {
    if (!this.getShowAddVariationButton()) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Button, {
      onClick: this.props.onAddVariation,
      use: "link",
      marginBlockEnd: "200",
      children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('buttons.addVariation')
      })]
    }, "addVariationButton");
  }
  renderMasterVariationName() {
    const {
      masterVariationName,
      onMasterVariationNameChange,
      mabExperimentIsStarted
    } = this.props;
    return /*#__PURE__*/_jsx(FormControl, {
      "aria-label": "Original variation name",
      error: masterVariationName.length === 0,
      validationMessage: this.renderMasterVariationValidationMessage(),
      marginBlockEnd: "200",
      children: mabExperimentIsStarted ? /*#__PURE__*/_jsx("span", {
        children: masterVariationName
      }) : /*#__PURE__*/_jsx(TextInput, {
        onChange: onMasterVariationNameChange,
        value: masterVariationName
      })
    }, "masterVariation");
  }
  renderMetric() {
    return /*#__PURE__*/_jsxs(View, {
      paddingBlockEnd: "300",
      as: "div",
      children: [/*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('metric.label')
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('metric.tooltip')
        }),
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "100",
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey(`metrics.${SUBMISSIONS}`)
          })
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey(`metric.description.${SUBMISSIONS}`)
      })]
    });
  }
  renderVariations() {
    return /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('variationFields')
      }),
      children: /*#__PURE__*/_jsxs(FoundationsList, {
        wrapChildren: true,
        children: [this.renderMasterVariationName(), this.props.variations.map(this.renderNewVariation), this.renderAddVariationButton()]
      })
    });
  }
  renderMasterVariationValidationMessage() {
    const {
      masterVariationName
    } = this.props;
    return masterVariationName.length === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('validationErrorMessage.emptyMasterVariationName')
    }) : null;
  }
  renderVariationValidationMessage(variation) {
    if (isValid(variation)) {
      return null;
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey(`validationErrorMessage.${variation.get('error')}`)
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(Form, {
      "data-test-id": "test-controls__mab",
      children: [this.renderMetric(), this.renderVariations()]
    });
  }
}
const MABExperimentModalControlsFields = withTheme(MABExperimentModalControlsFieldsWithoutTheme);
export default MABExperimentModalControlsFields;